import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { StoreState } from '@mm/state/store-interfaces';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { AD_ACCOUNT_NOT_SELECTED, LINK_AD_ACCOUNT } from '../../constants/ads';
import { CHATBOT_EDITOR } from '../../constants/routes';
import { RouterComponentProps } from '../../helpers/routes/interfaces';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import './LinkAdAccountModal.pcss';

type OuterProps = {
  closeModal: () => void;
};

type InnerProps = RouterComponentProps & ReturnType<typeof mapStateToProps>;

type Props = InnerProps & OuterProps;

const LinkAdAccountModal = ({ closeModal, history, chatbot }: Props) => (
  <div>
    <ModalHeader
      closeOverride={() => {
        closeModal();
        history.push(
          `${CHATBOT_EDITOR}/${chatbot && chatbot.id}/configure/advertising`,
        );
      }}
    >
      Link Ad Account
    </ModalHeader>
    <ModalBody className="link_ad_account_modal__body">
      {AD_ACCOUNT_NOT_SELECTED}
    </ModalBody>
    <ModalFooter>
      <Button
        blue
        onClick={() => {
          closeModal();
          history.push(
            `${CHATBOT_EDITOR}/${chatbot && chatbot.id}/configure/advertising`,
          );
        }}
      >
        {LINK_AD_ACCOUNT}
      </Button>
    </ModalFooter>
  </div>
);

const mapStateToProps = (state: StoreState) => ({
  chatbot: state.chatbot.activeChatbot,
});

const enhance = compose<InnerProps, OuterProps>(
  withRouter,
  connect(mapStateToProps, null),
);

export default enhance(LinkAdAccountModal);
